import { HttpClient } from '#client/http/index'
import {
  CanRequestResponse,
  ProgramId,
  ListTimetablesResponse,
  MyRequestsResponse,
  CreateReservationRequestParams,
  ReservationRequestId,
} from '#client/resources/index'

export const canRequest = async ({
  httpClient,
}: {
  httpClient: HttpClient
}) => {
  const { data } = await httpClient.get<CanRequestResponse>(
    '/user/reservationRequests/canRequest',
  )
  return data
}

export const listTimetables = async (
  { httpClient }: { httpClient: HttpClient },
  programId: ProgramId,
  params?: { date: string },
) => {
  const { data } = await httpClient.get<ListTimetablesResponse>(
    `/user/reservationRequests/program/${programId}/timetables`,
    { params },
  )
  return data
}

export const myRequests = async ({
  httpClient,
}: {
  httpClient: HttpClient
}) => {
  const { data } = await httpClient.get<MyRequestsResponse>(
    '/user/reservationRequests',
  )
  return Array.isArray(data) && data.length === 0 ? null : data
}

export const create = async (
  { httpClient }: { httpClient: HttpClient },
  params: CreateReservationRequestParams,
) => {
  return await httpClient.post('/user/reservationRequests', params)
}

export const cancel = async (
  { httpClient }: { httpClient: HttpClient },
  reservationRequestId: ReservationRequestId,
) => {
  return await httpClient.put('/user/reservationRequests/cancel', {
    reservationRequestId,
  })
}

export const confirm = async (
  { httpClient }: { httpClient: HttpClient },
  reservationRequestId: ReservationRequestId,
) => {
  return await httpClient.put('/user/reservationRequests/confirm', {
    reservationRequestId,
  })
}
